export default __webpack_public_path__ + "static/media/baseline-home-24px.f616fc18.svg";